/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($) {

    $.fn.unveil = function(threshold, callback) {

        var $w = $(window),
            th = threshold || 0,
            retina = window.devicePixelRatio > 1,
            // attrib = retina? "data-src-retina" : "data-src",
            images = this,
            loaded;

      /*if ($(window).width() >= 1628) {
       var attrib = 'data-src-xxl';
       } else */
        if ($(window).width() >= 1200) {
            var attrib = 'data-src-xl';
        } else if ($(window).width() >= 992) {
            var attrib = 'data-src-lg';
        } else if ($(window).width() >= 768) {
            var attrib = 'data-src-md';
        } else if ($(window).width() >= 375) {
            var attrib = 'data-src-sm';
        } else {
            var attrib = 'data-src-xs';
        }

        this.one('unveil', function() {
            var source = this.getAttribute(attrib);
            source = source || this.getAttribute('data-src-lg');
            if (source) {
                if ($(this).hasClass('unveil')) {
                    $(this).css('background-image', source);
                } else {
                    var source = JSON.parse(source);
                    // if (retina) {
                    //   source.src=source.src.replace('.png','@2x.png');
                    //   source.src=source.src.replace('.jpg','@2x.jpg');
                    //   this.setAttribute('src', source.src);
                    // } else {
                    this.setAttribute('src', source.src);
                    // }
                    this.setAttribute('width', source.width);
                    this.setAttribute('height', source.height);
                }
                if (typeof callback === 'function') callback.call(this);
            }
        });

        function unveil() {
            var inview = images.filter(function() {
                var $e = $(this);
                //if ($e.is(":hidden")) return;

                var wt = $w.scrollTop(),
                    wb = wt + $w.height(),
                    et = $e.offset().top,
                    eb = et + $e.height();

                return eb >= wt - th && et <= wb + th;
            });

            loaded = inview.trigger('unveil');
            images = images.not(loaded);
        }

        $w.on('scroll.unveil resize.unveil lookup.unveil', unveil);

        unveil();

        return this;

    };

})(window.jQuery || window.Zepto);
